import { 
  OperationVariables, QueryHookOptions, TypedDocumentNode, 
  useLazyQuery
} from '@apollo/client'

import { DocumentNode } from 'graphql';
import { parseErrors } from '../graphql';
import { useSnackbarMessage } from "./useSnackbarMessage";

function useSnackbarLazyQuery(
  query: DocumentNode | TypedDocumentNode<any, OperationVariables>,
  options: QueryHookOptions<any, OperationVariables> = {}
) {
  const { raiseErrorSnackbar } = useSnackbarMessage();

  return useLazyQuery(
    query,
    {
      onError: (e) => {
        raiseErrorSnackbar(
          parseErrors(e)
        );
      },
      ...options
    }
  )
}

export { useSnackbarLazyQuery };
